import React from 'react';

import { AutoComplete } from 'antd/es';
import Input from 'antd/es/input/Input';

interface CustomAutoCompleteProps {
	placeholder: string;
	field: any;
	onChange: (value: string, option: any) => void;
	onBlur: () => void;
	allowClear?: boolean;
	adjustValue?: boolean;
	label?: string | number;
	options?: Array<any>;
	onFocus?: (e: any) => void;
	onSelect?: any;
	setStateFormLabel?: (e: string) => void;
	customFilter?: (input: string, option: string) => boolean;
}

const CustomAutoComplete: React.FC<CustomAutoCompleteProps> = ({
	options,
	placeholder,
	field,
	onSelect,
	onChange,
	onBlur,
	label,
	onFocus,
	allowClear = false,
	setStateFormLabel,
	adjustValue,
	customFilter,
}) => {
	const ref = React.useRef<any>(null);

	const removeFocus = () => {
		setTimeout(() => ref?.current?.blur(), 300);
	};

	const setAdjustedValue = (item) => {
		field.form.setFieldValue(field.field.name, item.value);
		setStateFormLabel && setStateFormLabel(item.label);
	};

	const resetAdjustedValue = () => {
		field.form.setFieldValue(field.field.name, '', false);
		setStateFormLabel && setStateFormLabel('');
		field.form.setFieldError(field.field.name, 'Choose correct state name from list');
	};

	const passAdjustedValue = () => {
		if (options && options.length) {
			const value = field.field.value.toLowerCase();

			const possibleValues = options
				.filter((item) => item.label.toLowerCase().indexOf(value) !== -1)
				.sort((a, b) => a.label.toLowerCase().indexOf(value) - b.label.toLowerCase().indexOf(value));

			const result = possibleValues.filter((item) => item.value.toLowerCase() === value);

			if (result.length) {
				setAdjustedValue(result[0]);
			} else {
				resetAdjustedValue();
			}

			return;
		}

		resetAdjustedValue();
	};

	return (
		<>
			<AutoComplete
				ref={ref}
				allowClear={allowClear}
				options={options}
				placeholder={placeholder}
				// autoComplete="new-password"
				onSelect={onSelect}
				onChange={(value: string, option: any) => {
					onChange(value, option);
					Object.keys(option || {})?.length && removeFocus();
				}}
				onBlur={() => {
					adjustValue && passAdjustedValue();
					onBlur();
				}}
				onFocus={(e) => onFocus && onFocus(e)}
				value={field.field.value}
				classNames={{ popup: { root: 'custom-field-dropdown' } }}
				filterOption={(inputValue, option = { value: 'not selected' }) => {
					if (customFilter) {
						return customFilter(inputValue, option.label || option.value);
					}

					return option.label && typeof option.label === 'string'
						? option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
						: option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
				}}
			>
				<Input />
			</AutoComplete>
			<div className="custom-field__placeholder-top">{placeholder}</div>
		</>
	);
};

export default CustomAutoComplete;
